import { render, staticRenderFns } from "./MinimalHeading.vue?vue&type=template&id=5cc288c5&scoped=true&"
import script from "./MinimalHeading.vue?vue&type=script&lang=js&"
export * from "./MinimalHeading.vue?vue&type=script&lang=js&"
import style0 from "./MinimalHeading.vue?vue&type=style&index=0&id=5cc288c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc288c5",
  null
  
)

export default component.exports